import { SocialMediaNetwork } from '@professocial/professocialTypes/types/commonTypes'
import { PostingError, Restrictions, PostingErrorCode } from '../shared/types/types'
import { NetworkType } from '@3m5/sm_publish-frontend-api'

export const roundToTwoDecimalPlaces = (width: number, height: number) => Math.round((width / height) * 100) / 100

const checkRatio = (width: number, height: number, socialMediaNetwork: SocialMediaNetwork, restrictions: Restrictions) => {
  const ratio = roundToTwoDecimalPlaces(width , height)
  const error: PostingError[] = []

  Object.keys(socialMediaNetwork).map((network:string) => {
    let networkType: NetworkType = NetworkType.Facebook
    if (network === 'instagram') {
      networkType = NetworkType.Instagram
    }
    if (network === 'googleMyBusiness') {
      networkType = NetworkType.GoogleMyBusiness
    }
    if (socialMediaNetwork[network] && restrictions[network]) {
      // ratio
      const minAspectRatio = restrictions[network].image?.minAspectRatio
      if (minAspectRatio && ratio < minAspectRatio) {
        error.push({
          errorCode: PostingErrorCode.errorImageRatioWrong,
          network: networkType,
        })
      }

      const maxAspectRatio = restrictions[network].image?.maxAspectRatio
      if (maxAspectRatio && ratio > maxAspectRatio) {
        error.push({
          errorCode: PostingErrorCode.errorImageRatioWrong,
          network: networkType,
        })
      }
    }
  })
  return error
}

export default checkRatio
